/**
 * exportHeaders.js
 *
 * This file defines the mapping of export header keys to their corresponding
 * field names or callback functions for data export operations.
 * Used for exporting registrant data with proper formatting and labels.
 */

export default {
  // Basic user info fields
  Email: 'email',
  FirstName: 'firstName',
  LastName: 'lastName',
  PhoneNumber: 'phoneNumber',

  // Attendance status fields
  IsAttendingAMSession: 'isAttendingAMSession',
  IsAttendingPMSession: 'isAttendingPMSession',
  IsAttendingPlenary: 'isAttendingPlenary',
  isFinalConfirmed: 'isFinalConfirmed',
  IsHolRegistrant: 'isHolRegistrant',
  IsGigRegistrant: 'isGigRegistrant',

  // Status field with custom formatting callback
  Status: {
    /**
     * Returns a human-readable status string based on item properties.
     * @param {Object} item - The registrant object.
     * @returns {string} Status label.
     */
    callback: (item) => {
      if (item.isRejected) return 'Rejected';
      if (item.isPending && !item.isConfirmed) return 'Pending';
      if (item.isConfirmed && !item.isAttending) return 'Confirmed';
      if (item.isAttending && item.isConfirmed) return 'Attending';
      return '';
    },
  },

  // Date registered field with custom formatting callback
  DateRegistered: {
    /**
     * Formats the registration date as MM/DD/YYYY, HH:MM (UTC).
     * @param {Object} item - The registrant object.
     * @returns {string} Formatted date string.
     */
    callback: (item) => {
      try {
        const parsedDate = new Date(item.dateCreated);
        const options = {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'UTC',
        };
        return new Intl.DateTimeFormat('en-US', options).format(parsedDate);
      } catch {
        return '';
      }
    },
  },

  // Additional user info fields
  Company: 'company',
  Industry: 'industry',
  Role: 'role',
  Function: 'function',
  RoleFunction: 'roleFunction',
};
